import React, {useState} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import {deleteData, postData} from "../api/AuthenticatedApiCaller";
import {TraitsApi} from "../api/AdminApi";
import OperationResult from "../commons/OperationResult";
import {Box} from "@mui/material";

export default function TraitAddDialog(props) {
	const [hasError, setHasError] = useState(null);

	const updatedTrait = props.trait !== null
		? JSON.parse(JSON.stringify(props.trait))
		: {
			"id": null,
			"type": props.type,
			"contents": createEmptyContents()
		}

	function createEmptyContents() {
		return props.languages.map((language) => {
			return {"text": "", language}
		})
	}

	async function save() {
		let [data, error] = await postData(TraitsApi.setTrait, updatedTrait);
		if (!error) {
			setHasError(false)
		} else {
			setHasError(true)
		}
		props.save()
	}

	async function deleteTrait() {
		let [data, error] = await deleteData(TraitsApi.deleteTrait, updatedTrait.id);
		if (!error) {
			setHasError(false)
		} else {
			setHasError(true)
		}
		props.save()
	}

	return (
		<Box>
			{hasError !== null && <OperationResult success={!hasError}/>}

			<Dialog open={props.open}>
				<DialogTitle>Edit Trait</DialogTitle>
				<DialogContent>
					<Stack
						sx={{width: "100%", height: "100%"}}
						component="paper"
						spacing={4}
					>
						{updatedTrait.contents.map((content) => (
							<TextField
								defaultValue={content.text}
								label={content.language}
								onChange={(event) => {
									content.text = event.target.value;
								}}
							/>
						))}
					</Stack>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={save}
					>
						Save
					</Button>
					<Button onClick={props.cancel} autoFocus>
						Cancel
					</Button>
					{updatedTrait.id !== null && (
						<Button onClick={deleteTrait} autoFocus>
							Delete
						</Button>
					)}

				</DialogActions>
			</Dialog>
		</Box>
	);
}
